import { lazy } from 'react';
import { SubTabsConfig } from './TabConfig';

const componentMap = {
	orderQty: lazy(() => import('./Qty')),
};
export const subTabs = {
	ISSUED: SubTabsConfig?.issued?.map((subTab) => ({
		...subTab,
		comp: (props) => {
			const Component = componentMap.orderQty;
			return <Component {...props} />;
		},
	})),
	PRODUCED: SubTabsConfig?.produced?.map((subTab) => ({
		...subTab,
		comp: (props) => {
			const Component = componentMap.orderQty;
			return <Component {...props} />;
		},
	})),
	DISPATCHED: SubTabsConfig?.dispatched?.map((subTab) => ({
		...subTab,
		comp: (props) => {
			const Component = componentMap.orderQty;
			return <Component {...props} />;
		},
	})),
	INDENT: SubTabsConfig?.indent?.map((subTab) => ({
		...subTab,
		comp: (props) => {
			const Component = componentMap.orderQty;
			return <Component {...props} />;
		},
	})),
};
